
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: { StoryblokComponent },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // element: null,
      // isSVG: false,
      imgSrc: null,
      imgAlt: '',
      // hoverTimeline: null,
    }
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.hoverEffectInit()

  //     if (this.blok.animateType === 'reveal') {
  //       // this.initAnimation()
  //     }
  //   })
  // },
  // methods: {
  //   initAnimation() {
  //     const mm = this.$gsap.matchMedia()

  //     mm.add(
  //       '(min-width: 1024px)',
  //       () => {
  //         const q = this.$gsap.utils.selector(this.$el)

  //         this.$nextTick(() => {
  //           this.$gsap
  //             .timeline({
  //               paused: true,
  //               scrollTrigger: {
  //                 trigger: this.$refs.imgContainer,
  //                 start: 'top bottom-=10%',
  //                 emd: 'bottom center',
  //                 toggleActions: 'play none none reverse',
  //                 // scrub: 0.5,
  //                 // markers: true,
  //               },
  //             })
  //             .from(
  //               this.$gsap.utils.toArray(q('.img-blok')),
  //               {
  //                 top: '-2%',
  //                 left: '3%',
  //                 duration: 0.8,
  //                 ease: 'power2.out',
  //               },
  //               0
  //             )
  //         })
  //       },
  //       this.$refs.imgContainer
  //     )
  //   },
  //   hoverEffectInit() {
  //     this.hoverTimeline = this.$gsap
  //       .timeline({
  //         paused: true,
  //       })
  //       .from(this.$refs.captionContainer, {
  //         yPercent: 100,
  //         opacity: 0,
  //         duration: 0.2,
  //       })
  //   },
  //   onHover() {
  //     if (
  //       this.blok.hoverEffectCaption === 'none' ||
  //       !this.blok.hoverEffectCaption
  //     ) {
  //       return
  //     }

  //     this.hoverTimeline.play()
  //   },
  //   onLeave() {
  //     this.hoverTimeline.reverse()
  //   },
  // },
}
